import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { ProAccount, PagedResult } from '../../models';


export interface IProAccountService {

	get(proId: string, accountId: string): Promise<ProAccount>;
	list(proId: string): Promise<ProAccount[]>;
	page(proId: string, pageIndex: number, pageSize: number): Promise<PagedResult<ProAccount>>;
	save(model: ProAccount): Promise<ProAccount>;
	delete(proId: string, accountId: string): Promise<any>;

}

@injectable()
export class ProAccountService implements IProAccountService {


	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) {}


	public get(proId: string, accountId: string): Promise<ProAccount> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/accounts/${accountId}`;
		return this.httpClient.get<ProAccount>(url);
	}

	public list(proId: string): Promise<ProAccount[]> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/accounts`;
		return this.httpClient.get<ProAccount[]>(url);
	}

	public page(proId: string, pageIndex: number, pageSize: number): Promise<PagedResult<ProAccount>> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/accounts/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<ProAccount>>(url);
	}

	public save(model: ProAccount): Promise<ProAccount> {
		let url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${model.proId}/accounts`;
		if (model.id !== null && model.id !== undefined && model.id !== '') {
			url += `/${model.id}`;
			return this.httpClient.put(url, model);
		}
		return this.httpClient.post(url, model);
	}

	public delete(proId: string, accountId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/accounts/${accountId}`;
		return this.httpClient.delete(url);
	}

}
